<template>
  <div>
    <bottom-bar :hideBotton="zap"/>
    <div class="content" :class="{'pb-4': zap}">
      <div class="container-fluid mb-3" style="z-index: 10;">
        <div class="row no-gutters text-center mb-2">
          <div class="col pr-1">
            <a href="javascript:" class="text-muted small py-2 menu-info" :class="{'active': selectedPedido === 1}" @click="togglePedido(1)">Em andamento</a>
          </div>
          <div class="col pr-1">
            <a href="javascript:" class="text-muted small py-2 menu-info" :class="{'active': selectedPedido === 2}" @click="togglePedido(2)">Finalizados</a>
          </div>
        </div>
      </div>
      <div class="container-fluid">
        <loading v-show="load" :fullscrean="true" text="Carregando os dados"/>
        <div v-show="!load">
          <div v-if="token">
            <div v-show="selectedPedido === 1">
              <pedido :pedidos="andamento" :andamento="true" @atualizar="buscarPedidos(1)" @pagarPedido="pagarPedidoPix" @modalDescricao="msgPagamento" @abrirPedido="buscarPedidoId"/>
            </div>
            <div v-show="selectedPedido === 2">
              <pedido :pedidos="finalizados" @abrirPedido="buscarPedidoId"/>
            </div>
          </div>
          <div class="text-center" v-show="(!andamento.length && selectedPedido === 1) || (!finalizados.length && selectedPedido === 2)" style="padding-top: 15vh">
            <icon name="pedido" class="text-primary" size="65"></icon>
            <div class="py-3" v-if="!token">
              <label class="d-block mb-3">Faça o login para acompanhar seus pedidos</label>
              <router-link :to="url + '/perfil'" class="btn btn-outline-primary">Fazer Login</router-link>
            </div>
            <div class="py-4" v-else>
              <div v-if="selectedPedido === 1">Nenhum pedido em andamento!</div>
              <div v-else>Nenhum pedido finalizado!</div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <pix-pagamento ref="modalPix" :empresa="empresa" @atualizar="buscarPedidos(1)"/>

    <modal-bottom :opened="modalDescricao" v-if="descPedido">
      <div class="container-fluid">
        <div class="mt-2">
          <div class="text-center mb-3">
            <div v-if="descPedido.id_contador">Pedido: {{descPedido.id_contador}}</div>
            <h6 class="font-weight-bold mb-0">Valor a pagar: {{descPedido.valor_total | valor}}</h6>
          </div>
          <div class="mb-3" v-html="descPedido.descricao_pagamento" style="white-space: pre-line"></div>
          <div class="d-flex mb-2">
            <button class="btn btn-primary btn-block m-1" @click="modalDescricao = false">
              Ok, estou ciente!
            </button>
          </div>
        </div>
      </div>
    </modal-bottom>

    <modal ref="modalPedido" title="Pedido" @voltar="$emit('closeModal')" :overflow="true">
      <loading v-if="loadPedido"/>
      <div v-else-if="pedido">
        <div class="container-fluid mt-3 pb-3" v-show="menu === 1">
          <h5 class="mb-2 text-center">{{empresa.nome_fantasia}}</h5>
          <div class="p-2 mb-3 border rounded-lg bg-light text-center">
            <div class="font-weight-bold">
              #{{pedido.id_contador}}
            </div>
            <div class="tamanho-2">
              {{pedido.data_pedido}} |
              <span class="text-nowrap" v-if="!pedido.data_agendamento && pedido.previsao">
                Previsão {{pedido.tipo_pedido === '1' ? '(entrega)' : '(retirada)'}}: <b>{{getPrevisao()}}</b>
              </span>
            </div>
            <div class="tamanho-2" v-if="pedido.nolocal">Local: {{ pedido.nolocal }}</div>
          </div>
          <div class="text-center" v-if="pedido.data_agendamento">
            <div class="font-weight-bold">**PEDIDO AGENDADO**</div>
            <div class="small">{{pedido.data_agendamento}}</div>
            <hr>
          </div>
          <div class="alert alert-info small" v-if="!pedido.produtos.length">
            Os produtos deste pedido não estão mais disponíveis.
          </div>
          <div v-else>
            <div class="row produtos" v-for="i in pedido.produtos">
              <div class="col">
                <div class="mb-0 tamanho-1"><b>{{i.quantidade}}x</b> {{i.produto.nome_produto}}</div>
                <div v-for="d in i.divisoes" class="m-0 pl-2 tamanho-2"> # {{d.nome_produto}}</div>
                <div v-for="d in i.adicionais" class="m-0 pl-2 tamanho-2">
                  <b v-show="d.qtd > 1">{{d.qtd}}x</b> + {{d.nome_produto}}
                  <span v-show="d.valor > 0">{{(d.qtd * d.valor) | valor}}</span>
                </div>
                <div class="m-0 pl-2 tamanho-2" v-show="i.observacao">
                  <b>Obs:</b> {{i.observacao}}
                </div>
              </div>
              <div class="col-5 text-right tamanho-1">
                <span v-if="i.valor > 0">{{i.quantidade * i.valor | valor}}</span>
                <span class="badge badge-success" v-else>Grátis</span>
              </div>
            </div>
            <hr>
          </div>
          <div v-if="pedido.origin !== '4'">
            <div class="row" v-if="pedido.id_pagamento !== '5'">
              <div class="col">Pagamento:</div>
              <div class="col-5 align-self-center text-right">
                {{pedido.nome_pagamento}}
              </div>
            </div>
            <div class="row" v-show="pedido.troco > 0">
              <div class="col">
                Troco p/:
              </div>
              <div class="col-5 align-self-center text-right">
                {{pedido.troco | valor}}
              </div>
            </div>
            <div class="row">
              <div class="col">
                Subtotal:
              </div>
              <div class="col-4 align-self-center text-right">
                {{(parseFloat(pedido.valor_total) + parseFloat(pedido.valor_desconto) - parseFloat(pedido.valor_frete)) - parseFloat(pedido.valor_taxa ? pedido.valor_taxa : 0) | valor}}
              </div>
            </div>
            <div class="row" v-show="pedido.valor_desconto > 0">
              <div class="col">
                Desconto:
              </div>
              <div class="col-4 align-self-center text-right">
                {{pedido.valor_desconto | valor}}
              </div>
            </div>
            <div class="row" v-show="parseInt(pedido.tipo_pedido) === 1">
              <div class="col">
                Entrega:
              </div>
              <div class="col-4 align-self-center text-right">
                {{pedido.valor_frete | valor}}
              </div>
            </div>
            <div class="row" v-show="pedido.valor_taxa && pedido.valor_taxa !== '0'">
              <div class="col">
                {{pedido.valor_taxa > 0 ? 'Taxa' : 'Desconto'}} Pagamento
              </div>
              <div class="col-4 align-self-center text-right">
                {{pedido.valor_taxa | valor}}
              </div>
            </div>
            <div class="row font-weight-bold">
              <div class="col-4">
                Total:
              </div>
              <div class="col-8 align-self-center text-right h6">
                {{pedido.valor_total | valor}}
              </div>
            </div>
          </div>
          <div class="p-2 mb-2 border rounded-lg bg-light" v-if="pedido.obs_pedido">
            <div class="small font-weight-bold">Observação do pedido</div>
            {{ pedido.obs_pedido }}
          </div>
        </div>
        <form @submit.prevent="enviarAvaliacao()" v-show="menu === 2">
          <div class="container-fluid container-endereco text-center">
            <div class="p-2 border rounded-lg bg-light mb-3">
              <h6 class="mb-1 font-weight-bold">Pedido: {{pedido.id_contador}}</h6>
              <div class="small">Data: {{pedido.data_pedido}}</div>
            </div>
            <div class="alert alert-warning" v-show="pedido.dias_pedido > 15"><i class="fa fa-info-circle text-warning mr-1"></i> O prazo para avaliar este pedido já se encerrou.</div>
            <div class="form-group my-4">
              <h6 class="font-weight-bold mb-1">O que você achou do pedido?</h6>
              <p class="small">Escolha de 1 a 5 estrelas para avaliar</p>
              <div class="mb-1">
                <a href="javascript:" class="text-warning"><i class="fa fa-3x pointer mr-2" :class="pedido.nota < 1 ? 'fa-star-o' : 'fa-star'" @click="toggleNota(1)"></i></a>
                <a href="javascript:" class="text-warning"><i class="fa fa-3x pointer mr-2" :class="pedido.nota < 2 ? 'fa-star-o' : 'fa-star'" @click="toggleNota(2)"></i></a>
                <a href="javascript:" class="text-warning"><i class="fa fa-3x pointer mr-2" :class="pedido.nota < 3 ? 'fa-star-o' : 'fa-star'" @click="toggleNota(3)"></i></a>
                <a href="javascript:" class="text-warning"><i class="fa fa-3x pointer mr-2" :class="pedido.nota < 4 ? 'fa-star-o' : 'fa-star'" @click="toggleNota(4)"></i></a>
                <a href="javascript:" class="text-warning"><i class="fa fa-3x pointer" :class="pedido.nota < 5 ? 'fa-star-o' : 'fa-star'" @click="toggleNota(5)"></i></a>
              </div>
              <div class="small" v-if="pedido.nota > 0">{{ pedido.nota | nota }}</div>
              <div class="d-flex justify-content-between small mx-auto" style="max-width: 260px" v-else>
                <span>Ruim</span>
                <span>Excelente</span>
              </div>
            </div>
            <div class="form-group" v-show="pedido.nota">
              <h6 class="font-weight-bold mb-0" v-if="pedido.nota < 5 && pedido.nota > 0">O que podemos melhorar?</h6>
              <h6 class="font-weight-bold mb-0" v-else>Do que você gostou?</h6>
              <div v-if="pedido.dias_pedido <= 15">
                <label class="small mb-0">Digite no mínimo 10 caracteres</label>
                <textarea class="form-control mb-1 mt-2" id="comentario" placeholder="Eu achei que meu pedido.." v-model="pedido.comentario" rows="7" style="resize: none" minlength="10" maxlength="300" :required="pedido.nota !== 5"></textarea>
                <div class="small text-right">({{ (pedido.comentario || "").length }} / 300)</div>
              </div>
              <textarea class="form-control mt-3" rows="6" style="resize: none" disabled v-else>{{ pedido.comentario }}</textarea>
            </div>
          </div>
          <div class="fixed-bottom bg-white border-top btn-avancar fixed-container">
            <div class="p-2">
              <button type="submit" class="btn btn-primary btn-block btn-bottom" :disabled="!pedido.nota || loadAvaliacao || pedido.dias_pedido > 15">
                <span v-if="loadAvaliacao"><i class="fa fa-spinner fa-pulse"></i> Aguarde</span>
                <span v-else>Enviar avaliação</span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </modal>

  </div>
</template>

<script>
import BottomBar from '../components/BottomBar'
import Loading from '../components/Loading'
import Pedido from "../components/Pedido"
import Icon from "../components/Icon";
import PixPagamento from "../components/PixPagamento";
import ModalBottom from "../components/ModalBottom";
import Modal from "../components/Modal";

export default {
  name: 'Pedidos',
  components: {ModalBottom, Modal, PixPagamento, Icon, BottomBar, Loading, Pedido},
  data() {
    return {
      token: localStorage.getItem('token'),
      selectedPedido: 1,
      load: true,
      timeSync: '',
      connected: true,

      andamento: [],
      finalizados: [],
      url: null,
      modalDescricao: false,

      loadPedido: false,
      descPedido: null,
      pedido: null,

      menu: 1,
      loadAvaliacao: false
    }
  },

  methods: {
    togglePedido(sel) {
      if (this.selectedPedido === sel) {
        return;
      }

      this.selectedPedido = sel;

      if ((this.selectedPedido === 1 && !this.andamento.length) || (this.selectedPedido === 2 && !this.finalizados.length)) {
        this.buscarPedidos(this.selectedPedido);
      }
    },

    buscarPedidos(status, callback, openPagamento) {
      if (!this.token) {
        return;
      }

      const url = this.$helpers.base_url(this, this.empresa);
      this.load = true;

      this.$http.get(url + this.token + '/meus-pedidos', { params: { status } })
        .then(response => {
          const pedidos = response.data || {};

          if (status === 1) {
            this.andamento = pedidos.andamento || [];

            if (this.andamento.length) {
              let aPagar = this.andamento.find(p => p.status_pagamento === '1');

              if (aPagar && openPagamento) {
                this.pagarPedidoPix(aPagar);

              } else if (!aPagar) {
                this.$emit('closeModalPix');
              }

              if (this.andamento.filter(p => p.status === '2' && p.pontos).length) {
                this.pontosPedidos();
              }
            }

            localStorage.setItem('pedidos', this.andamento.length.toString());
            this.$emit('validarPedidos');

          } else {
            this.finalizados = pedidos.finalizados || [];
          }

          this.load = false;
          if (callback) callback();

        }, res => {
          this.load = false;
          if (res.status === 401 && res.data.result !== '') {
            this.$swal(res.data.result + ' ' + res.data.msg).then(() => {
              this.$store.commit('logout');
              this.$router.push(this.url + '/perfil');
            });
          }
        });
    },

    buscarPedidoId(id, avaliar) {
      this.loadPedido = true;
      this.pedido = null;
      this.menu = 1;
      this.$emit('openModal');
      const url = this.$helpers.base_url(this, this.empresa);

      this.$http.get(url + this.token + '/pedido?id_pedido=' + id)
        .then(response => {
          this.loadPedido = false;

          if (response.data && response.data.id_pedido) {
            this.pedido = response.data;

            if (avaliar && this.pedido.status === '4') {
              this.menu = 2;
              this.pedido.nota = parseInt(this.pedido.nota || '0');
            }

          } else {
            this.$emit('closeModal');
            this.$swal("Pedido não encontrado!");
          }

        }, res => {
          this.loadPedido = false;
        });
    },

    msgPagamento(p) {
      this.descPedido = p;
      this.modalDescricao = true;
    },

    onSwipe(event) {
      //esquerda
      if (event.direction === 2) {
        this.togglePedido(1)
      }

      //direita
      if (event.direction === 4) {
        this.togglePedido(2)
      }
    },

    sincronizar() {
      console.log('sync');
      this.timeSync = setTimeout(() => {
        this.buscarPedidos(1, () => {
          if (this.andamento.filter(p => p.status === '1' && !p.id_entrega).length) {
            this.sincronizar();
          }
        });
      }, 50000);
    },

    pontosPedidos() {
      if (this.empresa.fidelidade && !sessionStorage.getItem('confetti')) {
        sessionStorage.setItem('confetti','true');
        this.$confetti.start();
        this.$swal({
          icon: 'https://lecard-cdn.nyc3.digitaloceanspaces.com/lecard-corporativo/static/imgs/confetti-80x80.png',
          title: 'Você pontuou!',
          text: 'Confira seu saldo de pontos e veja os benefícios que você poderá trocar.',
          buttons: ["Voltar", "Ver meu saldo"],
        }).then((r) => {
          if (r) {
            this.$store.state.saldoFidelidade = null;
            this.$router.push(this.url + '/promocoes');

          } else {
            this.$confetti.stop();
          }
        })
      }
    },

    pagarPedidoPix(pedido) {
      this.$emit('openModalPix', pedido);
    },

    confirmarPagamento(payment_id, id_pedido) {
      this.load = true;

      const dados = {
        id_pedido: id_pedido,
        payment_id
      };

      this.$http.post(this.server + "confirmar-pagamento", dados)
        .then(res => {
          this.load = false;

          if (res.data.result) {
            const empresa = res.data.empresa;
            const msg = res.data.whatsapp;

            if ((msg || this.zap) && (empresa && empresa.whatsapp)) {
              const msgZap = (msg ? window.encodeURIComponent(msg) : "");
              const titulo = msg ?
                  "Pagamento confirmado com sucesso. Você será encaminhado para o WhatsApp, envie sem editar a mensagem para que possamos receber e aceitar seu pedido!"
                  : "Pagamento confirmado com sucesso. Você será encaminhado de volta para o nosso WhatsApp!";

              this.$swal(titulo).then(() => {
                window.location.assign("https://api.whatsapp.com/send?phone=55" + empresa.whatsapp + "&text=" + msgZap);
              });

            } else {
              this.$swal(res.data.msg ? res.data.msg : "Pagamento confirmado com sucesso. Aguarde seu pedido ser aceito!");
            }

          } else {
            this.$swal(res.data.msg ? res.data.msg : "Erro temporário!");
          }

          this.buscarPedidos(1);

        }, res => {
          this.load = false;
          this.buscarPedidos(1);
          console.log(res);
          let msg = res.data.msg ? res.data.msg : 'Erro temporário';
          this.$swal(msg);
        });
    },

    toggleNota(n) {
      if (parseInt(this.pedido.dias_pedido || '100') <= 15) {
        this.pedido.nota = n;
      }
    },

    enviarAvaliacao() {
      if ((this.pedido.nota !== 5 || this.pedido.comentario) && (!this.pedido.comentario || this.pedido.comentario.length < 10 || this.pedido.comentario.length > 300)) {
        this.$swal('Sua avaliação precisa ter de 10 a 300 caracteres').then(() => {
          this.$helpers.focusrElement('comentario');
        });

        return;
      }

      this.loadAvaliacao = true;
      const url = this.$helpers.base_url(this, this.empresa);
      const dados = { id_pedido: this.pedido.id_pedido, nota: this.pedido.nota, comentario: this.pedido.comentario }
      this.$http.post(url + this.token + "/avaliacao", dados)
        .then(res => {
          this.loadAvaliacao = false;

          if (res.data.success) {
            this.$emit('closeModal');
            this.$swal("Pedido avaliado com sucesso!");
            this.buscarPedidos(2);

          } else {
            this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
          }

        }, res => {
          this.loadAvaliacao = false;
          this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
        });
    },

    getPrevisao() {
      if (this.pedido) {
        return this.empresa.unidade_tempo !== '3' ? this.pedido.previsao.slice(-5) : `${this.pedido.previsao.substring(0, 10)}`;
      }
    },
  },

  mounted() {
    this.url = this.origin === '5' ? '/' + this.$store.state.empresa.dominio_delivery : '';

    if (this.token) {
      if (this.$route.query.payment_id && this.$route.query.external_reference) {        
        this.confirmarPagamento(this.$route.query.payment_id, this.$route.query.external_reference);
        this.sincronizar();

      } else {
        this.buscarPedidos(1,() => {
          if (this.andamento.length) {
            this.sincronizar();
            this.$store.state.modalPush = this.$store.state.modalPush + 1;
            const pedido = this.andamento.find(p => p.descricao_pagamento && p.status < 3);

            if (pedido) {
              this.msgPagamento(pedido);
            }

          } else {
            this.togglePedido(2);
          }

          if (this.$route.query.avaliar && !isNaN(this.$route.query.avaliar)) {
            this.buscarPedidoId(this.$route.query.avaliar, true);
          }

        }, true);
      }

    } else {
      this.load = false;
    }
  },

  sockets: {
    delivery_status: function (res) {
      this.buscarPedidos(1);
    },

    disconnect() {
      this.connected = false;
    },

    connect() {
      this.connected = true;
    },
  },

  beforeRouteLeave(to, from, next) {
    if (this.$refs.modalPix && this.$refs.modalPix.opened) {
      this.$emit('closeModalPix');
      next(false);

    } if (this.$refs.modalPedido && this.$refs.modalPedido.opened) {
      this.$emit('closeModal');
      next(false);

    } else {
      next()
    }
  },

  beforeDestroy() {
    if (this.$confetti) {
      this.$confetti.stop();
    }

    clearTimeout(this.timeSync);
  },

  computed: {
    empresa() {
      return this.$store.state.empresa
    },

    zap() {
      return this.$store.state.zap
    }
  },

  filters: {
    tipo_pedido(pedido) {
      switch (pedido.tipo_pedido) {
        case '1':
          return "Entregar";
        case '2':
          return "Retirar no Local";
        case '3':
          return "Consumir no Local";
      }
    },

    nota(n) {
      switch (n) {
        case 1: return 'Muito ruim';
        case 2: return 'Abaixo do esperado';
        case 3: return 'Razoável';
        case 4: return 'Muito bom';
        case 5: return 'Excelente!';
      }
    }
  }
}
</script>
<style scoped>
.container-endereco {
  overflow: auto;
  height: auto;
  padding-top: 22px;
  padding-bottom: 84px;
}

.produtos {
  padding-top: 4px;
}

.produtos:first-child {
  padding-top: 0;
}

@media (min-width: 768px) {
  .btn-avancar {
    position:static;
    padding-right: 15px;
    padding-left: 15px;
  }

  .container-endereco {
    padding-top: 18px;
    padding-bottom: 0;
    height: calc(80vh - 135px);
  }
}
</style>
